import type { UniDriver } from '@wix/unidriver-core';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

export const pulseAnimationDriverFactory = (
  base: UniDriver,
  body?: UniDriver,
) => {
  // Keep the second argument for testkit factory signature compatibility.
  void body;

  return {
    ...baseUniDriverFactory(base),
  };
};

export type PulseAnimationUniDriver = ReturnType<
  typeof pulseAnimationDriverFactory
>;

export default pulseAnimationDriverFactory;
